
export const btnCover = {
    py: "14px",
    px: 2,
    margin: "4px",
    borderRadius: "20px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  